<template>
  <div class="home">
    <Mall />
    <Business />
    <Guidelines />
    <Service />
    <Footer />
  </div>
</template>

<script>
import Mall from "./components/mall";
import Business from "./components/business";
import Guidelines from "./components/guidelines";
import Service from "./components/service";
import Footer from "../home/components/footer";
export default {
  name: "download_app",
  components: {
    Mall,
    Business,
    Guidelines,
    Service,
    Footer
  }
};
</script>

<style lang="scss" scoped>

</style>
